export const translations = {
  codigo: {
    pt: "Código",
    en: "Code",
    de: "Code",
    es: "Código",
  },
  nomeFantasia: {
    pt: "Nome Fantasia",
    en: "Fantasy name",
    de: "Fantasiename",
    es: "Nombre de fantasía",
  },
  cnpj: {
    pt: "CNPJ",
    en: "CNPJ",
    de: "CNPJ",
    es: "Numero de Identificacion",
  },
  cidade: {
    pt: "Cidade",
    en: "City",
    de: "Ort",
    es: "Ciudad",
  },
  tipo: {
    pt: "Tipo",
    en: "Type",
    de: "Typ",
    es: "Escribe",
  },
  ativo: {
    pt: "Ativo",
    en: "Active",
    de: "Aktiv",
    es: "Activo",
  },
  sim: {
    pt: "Sim",
    en: "Yes",
    de: "Ja",
    es: "Sí",
  },
  nao: {
    pt: "Não",
    en: "No",
    de: "Nein",
    es: "No",
  },
};
